import { apiGetRepTop30 } from "@api/repTop30";
import {
  setRepTop30Data,
  setRepTop30Loading,
  setRepTop30Error,
} from "@app-redux/slices/repTop30Slice";
import { createAsyncThunk } from "@reduxjs/toolkit";
import type { RepTop30Item } from "@api/repTop30";

type GetRepTop30Args = { repId: string; silent?: boolean };

export const getRepTop30 = createAsyncThunk<RepTop30Item[], GetRepTop30Args>(
  "repTop30/getTop30",
  async ({ repId, silent }, thunkAPI) => {
    try {
      if (!silent) {
        thunkAPI.dispatch(setRepTop30Loading());
      }
      const response = await apiGetRepTop30(repId);
      thunkAPI.dispatch(setRepTop30Data(response.data));
      return response.data;
    } catch (e: any) {
      thunkAPI.dispatch(
        setRepTop30Error(e.message ?? "Failed to fetch Rep Top 30")
      );
      return thunkAPI.rejectWithValue(e.message ?? e.response?.data?.message);
    }
  }
);
